import React from "react";
import { Link, useNavigate } from "react-router-dom";

import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";
import bg1 from "../../../assets/images/signup.jpg";

import BackToHome from "../../../components/back-to-home";
import Switcher from "../../../components/switcher";
import { useForm } from "react-hook-form";
import { signupValidationSchema } from "../../../utils/resolvers";
import InputField from "../../../components/inputField";
import { createClient } from "../../../utils/supbase/client";

export default function Signup() {
  const navigate = useNavigate();
  const supabase = createClient();
  const {
    handleSubmit,
    register,
    setValue,
    watch,
    setError,
    formState: { errors },
    reset,
  } = useForm({
    resolver: signupValidationSchema,
    defaultValues: {
      userName: "",
      LoginEmail: "",
      password: "",
    },
  });

  const handleSignup = async (formValues) => {
    console.log(formValues);
    try {
      let { data, error } = await supabase.auth.signUp({
        email: formValues.LoginEmail,
        password: formValues.password,
      });
      if (data) {
        let { data: updateData, error: updateError } = await supabase.auth.updateUser({
          data: { displayName: formValues.userName }
        });
        const { data: userTableData, error } = await supabase
          .from("users")
          .insert([
            {
              id: data.user.id,
              user_name: formValues.userName,
              email: data.user.email,
              email_verified: data.user.user_metadata.email_verified,
							role: "user"
            },
          ]);
        navigate("/signup-success");
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <section className="md:h-screen py-36 flex items-center bg-orange-500/10 dark:bg-orange-500/20 bg-[url('../../assets/images/hero/bg-shape.png')] bg-center bg-no-repeat bg-cover">
        <div className="container relative">
          <div className="grid grid-cols-1">
            <div className="relative overflow-hidden rounded-md shadow dark:shadow-gray-700 bg-white dark:bg-slate-900">
              <div className="grid md:grid-cols-2 grid-cols-1 items-center">
                <div className="relative md:shrink-0">
                  <img
                    className="h-full w-full object-cover md:h-[44rem]"
                    src={bg1}
                    alt=""
                  />
                </div>

                <div className="p-8 lg:px-20">
                  <div className="text-center">
                    <Link to="/">
                      <img
                        src={logoDark}
                        className="mx-auto block dark:hidden"
                        alt=""
                      />
                      <img
                        src={logoLight}
                        className="mx-auto hidden dark:block"
                        alt=""
                      />
                    </Link>
                  </div>

                  <form
                    onSubmit={handleSubmit(handleSignup)}
                    className="text-start lg:py-20 py-8"
                  >
                    <div className="grid grid-cols-1">
                      <div className="mb-4">
                        <label className="font-semibold" htmlFor="RegisterName">
                          Your Name:
                        </label>
                        <InputField
                          register={register}
                          onChange={(value) => {
                            setValue("userName", value);
                            setError("userName", null);
                          }}
                          errorMsg={errors?.userName?.message}
                          name="userName"
                          id="RegisterName"
                          type="text"
                          className="mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0"
                          placeholder="Harry"
                        />
                      </div>

                      <div className="mb-4">
                        <label className="font-semibold" htmlFor="LoginEmail">
                          Email Address:
                        </label>
                        <InputField
                          errorMsg={errors?.LoginEmail?.message}
                          onChange={(value) => {
                            setValue("LoginEmail", value);
                            setError("LoginEmail", null);
                          }}
                          register={register}
                          name="LoginEmail"
                          id="LoginEmail"
                          type="email"
                          className="mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0"
                          placeholder="name@example.com"
                        />
                      </div>

                      <div className="mb-4">
                        <label
                          className="font-semibold"
                          htmlFor="LoginPassword"
                        >
                          Password:
                        </label>
                        <InputField
                          errorMsg={errors?.password?.message}
                          onChange={(value) => {
                            setValue("password", value);
                            setError("password", null);
                          }}
                          register={register}
                          name="password"
                          id="LoginPassword"
                          type="password"
                          className="mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0"
                          placeholder="Password:"
                        />
                      </div>

                      <div className="mb-4">
                        <div className="flex items-center w-full mb-0">
                          <input
                            className="form-checkbox rounded border-gray-100 dark:border-gray-800 text-orange-500 focus:border-orange-300 focus:ring focus:ring-offset-0 focus:ring-orange-200 focus:ring-opacity-50 me-2"
                            type="checkbox"
                            value=""
                            id="AcceptT&C"
                          />
                          <label
                            className="form-check-label text-slate-400"
                            htmlFor="AcceptT&C"
                          >
                            I Accept{" "}
                            <Link to="" className="text-orange-500">
                              Terms And Condition
                            </Link>
                          </label>
                        </div>
                      </div>

                      <div className="mb-4">
                        <button
                          type="submit"
                          className="py-2 px-5 inline-block tracking-wide align-middle duration-500 text-base text-center bg-orange-500 text-white rounded-md w-full"
                        >
                          Register
                        </button>
                      </div>

                      <div className="text-center">
                        <span className="text-slate-400 me-2">
                          Already have an account ?{" "}
                        </span>{" "}
                        <Link
                          to="/login"
                          className="text-black dark:text-white font-bold inline-block"
                        >
                          Sign in
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <BackToHome />
      {/* <Switcher /> */}
    </>
  );
}
